module.exports = "\"data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M10 0L5 6L0 0L10 0Z' fill='%231B73AD' /%3E %3C/svg%3E\""


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/triangle-opened-over.svg
// module id = 113
// module chunks = 0